<!--
 * @Author: Tahiti
 * @Date: 2025-10-20 13:34:19
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 17:18:32
 * @Description: 
 * @FilePath: /weryai-web/components/AppSidebar.vue
-->
<template>
    <div ref="sidebarRef"
        class="left-menu flex flex-col max-w-[220px] max-md:hidden justify-between text-white bg-[#000000] group peer z-[48] px-[10px] pb-6 transition-[width] duration-300 ease-in-out"
        :class="[appStore.sidebarCollapsed ? 'w-[76px]' : '']">
        <!-- 顶部区域 -->
        <div class="top-section">
            <!-- Logo 区域 -->
            <div v-if="!appStore.sidebarCollapsed" class="logo-section mb-6 cursor-pointer flex justify-center"
                @click="backToWebsite">
                <img src="https://static.weryai.com/growth/image/weryai_5cb7d93ce37f69e6825b5bf4396a3d12.png" alt="logo"
                    class="w-[129px]" />
            </div>

            <create-new v-if="!appStore.sidebarCollapsed"></create-new>

            <!-- 菜单列表 -->
            <ClientOnly>
                <el-menu ref="menuRef" :default-active="activeMenu" class="overflow-y-auto overflow-x-hidden"
                    :unique-opened="true" :collapse="appStore.sidebarCollapsed" :collapse-transition="true" :style="{
                        transition: 'all .3s cubic-bezier(0.4, 0, 0.2, 1)',
                        paddingTop: appStore.sidebarCollapsed ? '50px' : '0px',
                    }" @select="handleMenuSelect">
                    <div v-for="item in filteredLeftMenuEnum" :key="item.path">
                        <!-- 子标题和分割线已隐藏 -->
                        <el-menu-item :index="item.no_lang_path" class="rounded-lg mb-1 relative"
                            :aria-label="item.name">
                            <!-- video-effects 和 photo-effects 用 img 原样显示 -->
                            <img v-if="item.icon === 'i-video-effects-icon'"
                                src="~/assets/images/menu/video-effects.png" alt="video effects"
                                class="w-5 h-5 shrink-0" />
                            <img v-else-if="item.icon === 'i-photo-effects-icon'"
                                src="~/assets/images/menu/photo-effects.png" alt="photo effects"
                                class="w-5 h-5 shrink-0" />
                            <!-- 其他图标继续用 CSS mask -->
                            <span v-else class="w-5 h-5 shrink-0" :class="item.icon" aria-hidden="true"></span>

                            <template #title>
                                <span class="ml-[10px] truncate text-xs">{{
                                    item.name
                                    }}</span>
                            </template>
                        </el-menu-item>
                    </div>
                </el-menu>
            </ClientOnly>
        </div>

        <!-- 底部区域 -->
        <div class="bottom-section space-y-4">
            <!-- 未登录：登录按钮（收窄时隐藏） -->
            <div v-if="!userInfo && !appStore.sidebarCollapsed && LOGIN_ENTRY_ENABLED" class="login-button-wrapper"
                @click="() => showLoginModal()">
                <button class="login-button">
                    {{ t('menus.login') }}
                </button>
            </div>

            <!-- 签到领积分入口（已登录且未收窄时显示） -->
            <SignInButton v-if="SIGN_IN_ENABLED && userInfo" />

            <!-- VIP 升级按钮（未登录或无会员时显示，收窄时隐藏） -->
            <VipUpgradeButton v-if="!appStore.sidebarCollapsed && !userInfo" />

            <!-- 已登录用户区域 -->
            <div v-if="userInfo" class="user-section space-y-3">
                <!-- 金币容器 -->
                <div class="coin-box" :class="[
                    coinContainerClass,
                    appStore.sidebarCollapsed
                        ? 'w-fit h-fit'
                        : 'min-w-[128px] h-[68px]',
                ]">
                    <!-- 上半部分：金币显示 -->
                    <div class="coin-area flex items-center cursor-pointer px-3" :class="appStore.sidebarCollapsed
                        ? 'justify-center py-2'
                        : 'justify-start h-[34px]'
                        " @click="handleCoinClickToPageJump">
                        <img src="~/assets/images/common/coin.webp" alt="credit" class="w-3.5 h-3.5 mr-1" />
                        <span class="text-white text-xs">
                            {{ formattedBalance }}
                        </span>
                    </div>

                    <!-- 下半部分：VIP信息区域 -->
                    <div class="vip-info-area rounded-t-lg" :class="appStore.sidebarCollapsed ? 'h-fit' : 'h-[35px]'
                        ">
                        <!-- 有会员：显示等级名称 -->
                        <div v-if="vipSubscriptionType"
                            class="flex items-center cursor-pointer hover:opacity-80 transition-opacity" :class="appStore.sidebarCollapsed
                                ? 'justify-center py-1.5 px-2'
                                : 'justify-between h-full px-3'
                                " @click="handleOpenVipModal">
                            <div class="flex items-center">
                                <span class="vip-text text-xs">{{
                                    vipLevelName
                                    }}</span>
                                <span v-if="!appStore.sidebarCollapsed" class="vip-text text-xs ml-1">›</span>
                            </div>
                            <!-- 右侧VIP等级图标（收起时隐藏） -->
                            <template v-if="!appStore.sidebarCollapsed">
                                <img v-if="vipIconName === 'vip-entry'" src="~/assets/images/common/vip-entry.png"
                                    alt="vip" class="w-[35px] h-[35px]" />
                                <img v-else-if="vipIconName === 'vip-basic'" src="~/assets/images/common/vip-basic.png"
                                    alt="vip" class="w-[35px] h-[35px]" />
                                <img v-else-if="vipIconName === 'vip-pro'" src="~/assets/images/common/vip-pro.png"
                                    alt="vip" class="w-[35px] h-[35px]" />
                            </template>
                        </div>
                        <!-- 没会员：显示开通会员 -->
                        <div v-else class="flex items-center cursor-pointer hover:opacity-80 transition-opacity" :class="appStore.sidebarCollapsed
                            ? 'justify-center py-1.5 px-2'
                            : 'justify-between h-full px-3'
                            " @click="handleOpenVipModal">
                            <div class="flex items-center">
                                <span class="vip-text text-xs">{{
                                    t('menus.startVip')
                                    }}</span>
                                <span v-if="!appStore.sidebarCollapsed" class="vip-text text-xs ml-1">›</span>
                            </div>
                            <!-- 右侧免费用户图标（收起时隐藏） -->
                            <img v-if="!appStore.sidebarCollapsed" src="~/assets/images/common/vip-free.png" alt="vip"
                                class="w-[25px] h-[24px]" />
                        </div>
                    </div>
                </div>

                <!-- 用户信息下拉菜单 -->
                <PopMenu ref="userMenuRef" trigger="click" position="side-right-bottom" :gap="8" width="min-w-48"
                    @open="handleUserMenuOpen">
                    <template #trigger>
                        <div class="flex items-center gap-2 cursor-pointer p-2 rounded-lg hover:bg-white/5 transition-colors duration-200"
                            :class="appStore.sidebarCollapsed
                                ? 'justify-center'
                                : ''
                                ">
                            <img v-if="userInfo?.avatar" :src="userInfo?.avatar" alt="user-avatar"
                                class="w-9 h-9 rounded-full flex-shrink-0" />
                            <div v-else
                                class="w-9 h-9 rounded-full flex-shrink-0 bg-[#3d3d3d] flex items-center justify-center">
                                <el-icon class="text-white text-lg">
                                    <User />
                                </el-icon>
                            </div>
                            <div v-if="!appStore.sidebarCollapsed"
                                class="text-xs max-w-[100px] text-white truncate flex-1 min-w-0">
                                {{ userInfo?.nick_name }}
                            </div>
                        </div>
                    </template>
                    <template #content>
                        <div class="p-2">
                            <button @click="handleMenuClick('profile')"
                                class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                <el-icon class="!text-base">
                                    <User />
                                </el-icon>
                                {{ t('menus.profile') }}
                            </button>
                            <button @click="handleMenuClick('billing')"
                                class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="h-4 w-4" aria-hidden="true">
                                    <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                    <line x1="2" x2="22" y1="10" y2="10"></line>
                                </svg>
                                {{ t('menus.billing') }}
                            </button>
                            <!-- 多语言切换器 -->
                            <div v-if="false && getCurrentLanguageName()" class="language-switcher">
                                <PopMenu ref="langMenuRef" trigger="hover" position="side-right-bottom" :gap="8"
                                    class="py-2 px-4" width="min-w-64">
                                    <template #trigger>
                                        <button class="language-button w-full" :class="appStore.sidebarCollapsed
                                            ? 'justify-center'
                                            : ''
                                            ">
                                            <img src="/assets/images/common/language.png" alt="language"
                                                class="w-4 h-4" />
                                            <span v-if="!appStore.sidebarCollapsed" class="text-sm">{{
                                                getCurrentLanguageName() }}</span>
                                        </button>
                                    </template>
                                    <template #content>
                                        <div
                                            class="p-2 max-h-[420px] overflow-y-auto grid grid-cols-2 gap-1 custom-scrollbar">
                                            <button v-for="lang in availableLanguages" :key="lang.code"
                                                class="px-3 py-2 text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center justify-start gap-2 rounded-md hover:bg-white/5"
                                                :class="{
                                                    '!text-text-active': locale === lang.code,
                                                }" @click="handleLanguageChange(lang.code)">
                                                <!-- <span class="text-base shrink-0">{{ lang.flag }}</span> -->
                                                <span class="truncate">{{ lang.name }}</span>
                                            </button>
                                        </div>
                                    </template>
                                </PopMenu>
                            </div>
                            <button
                                class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-red-500 hover:text-text-active transition-colors duration-200 flex items-center gap-2"
                                @click="handleMenuClick('logout')">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                    </path>
                                </svg>
                                <span>
                                    {{ t('menus.logout') }}
                                    <span class="ml-1 text-xs opacity-60">(v{{ version }})</span>
                                </span>
                            </button>
                        </div>
                    </template>
                </PopMenu>
            </div>

            <!-- 多语言切换器 (已隐藏) -->
            <div v-if="false && !userInfo && getCurrentLanguageName()" class="language-switcher">
                <PopMenu ref="langMenuRef" trigger="click" position="side-right-bottom" :gap="8" width="min-w-64"
                    @open="handleLangMenuOpen">
                    <template #trigger>
                        <button class="language-button w-full" :class="appStore.sidebarCollapsed
                            ? 'justify-center'
                            : ''
                            ">
                            <img src="/assets/images/common/language.png" alt="language" class="w-5 h-5" />
                            <span v-if="!appStore.sidebarCollapsed" class="text-xs">{{ getCurrentLanguageName()
                                }}</span>
                        </button>
                    </template>
                    <template #content>
                        <div class="p-2 grid grid-cols-2 gap-x-1 min-w-[320px]">
                            <button v-for="lang in availableLanguages" :key="lang.code"
                                class="px-3 py-2 text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center justify-start whitespace-nowrap"
                                :class="{
                                    '!text-text-active': locale === lang.code,
                                }" @click="handleLanguageChange(lang.code)">
                                <span>{{ lang.name }}</span>
                            </button>
                        </div>
                    </template>
                </PopMenu>
            </div>

            <!-- API 入口 -->
            <div class="api-entry flex gap-2" v-if="!appStore.sidebarCollapsed">
                <button class="history-button flex-1 h-10 flex items-center justify-center rounded-lg transition-colors"
                    :class="[recentlyUsedDrawerVisible ? 'active' : '']"
                    @click="handleMenuSelect(recentlyUsedMenu?.no_lang_path || '/recently-used')">
                    <div :class="recentlyUsedMenu?.icon || 'i-used-his-icon'" class="w-5 h-5 text-white" />
                </button>
                <button
                    class="api-button flex-1 h-10 flex items-center justify-center rounded-lg transition-colors"
                    :class="[isApiActive ? 'active' : '']" @click="handleApiClick">
                    <span class="text-white font-bold text-xs">API</span>
                </button>
            </div>
            <div class="api-entry" v-else>
                <button class="api-button w-full" :class="[
                    appStore.sidebarCollapsed ? 'justify-center' : '',
                    isApiActive ? 'active' : '',
                ]" @click="handleApiClick">
                    <img src="/assets/images/common/api.svg" alt="API" class="w-5 h-5" />
                    <span v-if="!appStore.sidebarCollapsed" class="text-xs">API</span>
                </button>
            </div>


            <div v-if="false" class="nav-links  ">
                <a href="https://x.com/weryai" target="_blank" rel="noopener noreferrer" aria-label="微鲤AI on X">
                    <span class="i-nav-twitter-icon navIcon"></span>
                </a>
                <button type="button" aria-label="微鲤AI Discord" @click="getUrl()">
                    <span class="i-nav-discord-icon navIcon"></span>
                </button>
                <a href="https://www.instagram.com/weryai_official/" target="_blank" rel="noopener noreferrer"
                    aria-label="微鲤AI Instagram">
                    <span class="i-nav-instagram-icon navIcon"></span>
                </a>
                <a href="https://www.tiktok.com/@weryai_" target="_blank" rel="noopener noreferrer"
                    aria-label="微鲤AI TikTok">
                    <span class="i-nav-tiktok-icon navIcon"></span>
                </a>
            </div>
        </div>
    </div>

    <!-- 历史记录抽屉 -->
    <RecentlyUsedDrawer v-model:visible="recentlyUsedDrawerVisible" @close="recentlyUsedDrawerVisible = false" />
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { User } from '@element-plus/icons-vue'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import { useI18n } from '~/composables/useI18n'
import { useRoute, navigateTo } from '#imports'
import { debounce, deleteLangPrefix, availableLanguages } from '@/utils/common'
import { analyticsEvent } from '~/utils/log-event-func'
import { useToolsHooks } from '@/utils/useHooks'
import { showLoginModal, emitter, emitOpenGoodsModal } from '@/utils/emitter'
import { useRecentlyUsed } from '~/composables/useRecentlyUsed'
import PopMenu from '@/components/ui/PopMenu.vue'
import SignInButton from '@/components/SignInButton.vue'
import RecentlyUsedDrawer from '@/components/RecentlyUsedDrawer.vue'
import { LOGIN_ENTRY_ENABLED, SIGN_IN_ENABLED } from '@/utils/feature-flags'

// 历史记录抽屉显示状态
const recentlyUsedDrawerVisible = ref(false)
import { getUserThirdPartyBindInfoApi } from '@/api/social-media'

const runtimeConfig = useRuntimeConfig()
const version = runtimeConfig.public.appVersion
const { LeftMenuEnums } = useToolsHooks()
const { t, locale, changeLanguage } = useI18n()

// 历史记录管理
const { initRecentlyUsed, hasRecentlyUsed, recentlyUsedList } = useRecentlyUsed()

// 提取历史记录菜单项配置
const recentlyUsedMenu = computed(() => {
    return LeftMenuEnums.value.find((item: any) => item.type === 'recently-used')
})

// 过滤后的菜单列表（不再在列表中显示历史记录，因为它将被移动到底部按钮）
const filteredLeftMenuEnum = computed(() => {
    return LeftMenuEnums.value.filter((item: any) => {
        return item.type !== 'recently-used'
    })
})
const route = useRoute()
const appStore = useAppStore()
const menuRef: any = ref(null)
const userStore = useUserStore()

// 弹窗 ref（用于互斥控制）
const userMenuRef = ref<InstanceType<typeof PopMenu> | null>(null)
const langMenuRef = ref<InstanceType<typeof PopMenu> | null>(null)

// 弹窗互斥：用户菜单打开时关闭语言菜单
const handleUserMenuOpen = () => {
    langMenuRef.value?.close()
}

// 弹窗互斥：语言菜单打开时关闭用户菜单
const handleLangMenuOpen = () => {
    userMenuRef.value?.close()
}

// 用户信息和余额
const balance = computed(() => userStore.balance || 0)

// 格式化金币数量（超过1万用w表示）
const formattedBalance = computed(() => {
    const val = balance.value
    if (val >= 10000) {
        return (val / 10000).toFixed(1) + 'w'
    }
    return val.toString()
})
const userInfo = computed(() => userStore.userInfo)

// VIP 信息
const accountSummary = computed(() => userStore.accountSummary)
const vipSubscriptionType = computed(
    () => accountSummary.value?.sub_info?.subscription_type
)
// VIP 等级名称
const vipLevelName = computed(() => {
    const type = vipSubscriptionType.value
    if (!type) return t('menus.freeUser')

    const levelMap: Record<string, string> = {
        PLAN_ENTRY: t('menus.planEntry'),
        PLAN_BASIC: t('menus.planBasic'),
        PLAN_PRO: t('menus.planPro'),
    }

    return levelMap[type] || t('menus.freeUser')
})

// 金币容器样式类名（根据会员等级）
const coinContainerClass = computed(() => {
    const type = vipSubscriptionType.value
    const classMap: Record<string, string> = {
        PLAN_ENTRY: 'coin-box-entry',
        PLAN_BASIC: 'coin-box-basic',
        PLAN_PRO: 'coin-box-pro',
    }
    return classMap[type] || 'coin-box-free'
})

// VIP图标路径映射
const vipIconMap: Record<string, string> = {
    PLAN_ENTRY: 'vip-entry',
    PLAN_BASIC: 'vip-basic',
    PLAN_PRO: 'vip-pro',
}

// 当前VIP图标名称
const vipIconName = computed(() => {
    const type = vipSubscriptionType.value
    return vipIconMap[type] || ''
})

// 侧边栏 DOM 引用：用于测量真实宽度，让内容区左边距动态跟随
const sidebarRef = ref<HTMLElement | null>(null)
let sidebarResizeObserver: ResizeObserver | null = null

const syncSidebarWidthToStore = () => {
    const el = sidebarRef.value
    if (!el) return
    const width = el.getBoundingClientRect().width
    appStore.setSidebarWidth(width)
}

// 屏幕尺寸监听
const isSmallScreen = ref(false)

// 检查屏幕尺寸
const checkScreenSize = () => {
    isSmallScreen.value = window.innerWidth < 1024

    // 同步到 store
    appStore.setIsSmallScreen(isSmallScreen.value)

    // 当屏幕小于1024px时自动收缩
    if (isSmallScreen.value && !appStore.sidebarCollapsed) {
        appStore.setSidebarCollapsed(true)
    } else if (!isSmallScreen.value) {
        appStore.setSidebarCollapsed(false)
    }
}

// 监听窗口大小变化（防抖处理）
const handleResize = debounce(() => {
    checkScreenSize()
}, 100)

// 组件挂载时检查屏幕尺寸
onMounted(() => {
    // userStore.getAccountSummary()
    checkScreenSize()
    window.addEventListener('resize', handleResize)

    // 初始化历史记录
    initRecentlyUsed()

    // 挂载后立即同步一次宽度
    syncSidebarWidthToStore()
    // 监听侧边栏自身宽度变化（收缩/展开、字体变化等），实时同步到 store
    if (typeof ResizeObserver !== 'undefined') {
        sidebarResizeObserver = new ResizeObserver(() => {
            syncSidebarWidthToStore()
        })
        if (sidebarRef.value) {
            sidebarResizeObserver.observe(sidebarRef.value)
        }
    }
})

// 组件卸载时移除监听器
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
    if (sidebarResizeObserver) {
        sidebarResizeObserver.disconnect()
        sidebarResizeObserver = null
    }
})

// 解析当前激活的菜单项
const activeMenu = computed(() => {
    return deleteLangPrefix(route.path)
})

// 判断 API 页面是否激活
const isApiActive = computed(() => {
    const currentPath = deleteLangPrefix(route.path)
    return currentPath.startsWith('/api')
})

const handleMenuSelect = (index: string): void => {
    // 历史记录菜单项：打开抽屉而不是跳转
    if (index === '/recently-used') {
        recentlyUsedDrawerVisible.value = true
        return
    }

    // 埋点：左侧菜单点击
    if (index.includes('video-effects')) {
        analyticsEvent('click_tab_video_effect')
    } else if (index.includes('photo-effects')) {
        analyticsEvent('click_tab_pic_effect')
    }
    // 关键：补齐当前 URL 的语言前缀（含 /en alias），避免触发全局中间件 replace 导致历史栈异常
    navigateTo(withUrlPrefix(index))
}

const discordLoading = ref(false)

// 获取discord链接地址
const getUrl = async () => {
    if (discordLoading.value) return
    discordLoading.value = true
    try {
        const res: any = await getUserThirdPartyBindInfoApi()
        console.log('响应结果', res)
        if (res.status !== 200) {
            ElMessage.warning(res.desc)
        } else {
            const discord_id = res.data?.discord_id
            if (discord_id != 0) {
                ElMessage.info(t('menus.discordBound'))
                window.open('https://discord.gg/xTY7vmwarm', '_blank')
            } else {
                const navUrl = res.data?.discord_auth_url
                if (navUrl) {
                    window.open(navUrl, '_blank')
                }
            }
        }
    } catch (err) {
        console.error('getUrl error:', err)
    } finally {
        discordLoading.value = false
    }
}

// ===== 多语言切换相关 =====
// 获取当前语言名称
const getCurrentLanguageName = () => {
    const currentLang = availableLanguages.find(
        lang => lang.code === locale.value
    )
    return currentLang ? currentLang.name : ''
}

// 语言切换处理
const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode)
}

// ===== URL 前缀处理 =====
/**
 * 计算"当前 URL 语言模式"的基础前缀
 * - /en/... => /en
 * - /ja/... => /ja
 * - 无前缀英文 => ''
 *
 * 注意：/en 通过 alias 实现，route.path 可能丢失 /en 前缀，所以优先取地址栏 pathname。
 */
const getUrlBasePrefix = () => {
    const supported = [
        'zh',
        'en',
        'ja',
        'ko',
        'es',
        'fr',
        'de',
        'ru',
        'pt',
        'it',
        'ar',
    ]
    const p =
        import.meta.client && typeof window !== 'undefined'
            ? window.location.pathname
            : route.path || '/'
    const m = p.match(/^\/([a-z]{2})(\/|$)/)
    const maybe = m?.[1]
    if (maybe && supported.includes(maybe)) {
        return maybe === 'en' ? '/en' : `/${maybe}`
    }
    return ''
}

const withUrlPrefix = (toPath: string) => {
    const base = getUrlBasePrefix()
    if (!base) return toPath
    if (toPath === '/') return base
    return `${base}${toPath}`
}

const backToWebsite = () => {
    navigateTo(withUrlPrefix('/'))
}

// 菜单项点击处理
const handleMenuClick = (action: string) => {
    if (action === 'logout') {
        userStore.logout()
        appStore.clearRecentCreatedOrder()
        // 使用 window.location 强制刷新页面以确保跳转成功
        window.location.href = withUrlPrefix('/')
        return
    } else if (action === 'profile') {
        emitter.emit('open-user-profile-modal')
    } else {
        // 使用 window.location 强制跳转到目标页面
        window.location.href = withUrlPrefix('/' + action)
    }
}

// 打开VIP弹窗
const handleOpenVipModal = () => {
    const path = route.path
    const type = path.includes('/characters') ? 'chat_plan' : ''
    emitOpenGoodsModal(type)
}

// 页面跳转
const handleCoinClickToPageJump = () => {
    if (balance.value == 0) {
        // 余额为0，跳转到 pricing 页面并显示按年计费
        navigateTo('/pricing?tab=yearly')
    } else {
        // 有余额，跳转到 pricing 页面并显示按积分收费
        navigateTo('/pricing?tab=credits')
    }
}

// 处理 API 按钮点击
const handleApiClick = () => {
    navigateTo(withUrlPrefix('/api'))
}
</script>

<style scoped lang="less">
.left-menu {
    position: fixed;
    top: 0;
    height: 100vh;
    padding-top: 20px;
    flex-direction: column;
    gap: 0.125rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    background: #000000;
}

.top-section {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.bottom-section {
    flex-shrink: 0;
    overflow: visible;
    position: relative;
    z-index: 50;
}

// Element UI Menu 样式覆盖
:deep(.el-menu) {
    background: transparent !important;
    border: none !important;
}

:deep(.el-menu-item) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    color: #ffffff;

    &.is-active {
        background: #3d3d3d !important;
        color: #ffffff !important;

        .i-home-icon,
        .i-ai-video-icon,
        .i-ai-image-icon,
        .i-ai-music-icon,
        .i-ai-tool-icon,
        .i-my-creations-icon,
        .i-text-to-image-icon,
        .i-image-to-image-icon,
        .i-text-to-video-icon,
        .i-img-to-video-icon,
        .i-video-to-video-icon,
        .i-video-effects-icon,
        .i-photo-effects-icon,
        .i-characters-icon {
            background-color: #ffffff !important;
        }
    }
}

:deep(.el-button--text) {
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s ease-in-out;
}

:deep(.el-button--text:hover) {
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
    transform: scale(1.05);
}

:deep(.el-icon) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.el-menu--collapse .el-menu-item) {
    text-align: center;
    padding: 0 20px;
}

@media (max-width: 1023px) {
    :deep(.el-menu) {
        --el-menu-collapse-width: 76px;
    }
}

:deep(.el-tooltip__popper) {
    background-color: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    font-size: 14px;
    padding: 8px 12px;
}

:deep(.el-tooltip__popper .el-popper__arrow::before) {
    background-color: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 登录按钮样式 */
.login-button {
    width: 128px;
    height: 38px;
    border-radius: 31px;
    border: 1px solid #3d3d3d;
    background: transparent;
    color: #99f768;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin: 0 auto;
}

.login-button:hover {
    background: rgba(153, 247, 104, 0.1);
    border-color: #99f768;
}

/* 多语言切换器样式 */
.language-switcher {
    position: relative;
}

.language-button {
    display: flex;
    white-space: nowrap;
    align-items: center;
    /* padding: 0.5rem 0.75rem; */
    padding: 0 !important;
    font-size: 0.875rem;
    color: white;
    border-radius: 0.5rem;
    transition: color 0.3s;
    gap: 8px;
    margin: 0 !important;
}

.language-button:hover {
    color: var(--text-active);
}

.history-button {
    padding: 0.625rem;
    border-radius: 8px;
    background: rgba(61, 61, 61, 0.13);

    &:hover {
        color: var(--text-active);
        background: rgba(255, 255, 255, 0.05);
    }

    &.active {
        background: #3d3d3d;
        color: #ffffff;

        img {
            filter: brightness(0) invert(1);
        }
    }
}

/* API 入口样式 */
.api-entry {
    position: relative;
}

.api-button {
    display: flex;
    white-space: nowrap;
    align-items: center;
    padding: 0.625rem;
    font-size: 0.75rem;
    color: white;
    border-radius: 8px;
    transition: all 0.3s;
    gap: 8px;
    background: rgba(61, 61, 61, 0.13);
    border: none;
    cursor: pointer;

    &:hover {
        color: var(--text-active);
        background: rgba(255, 255, 255, 0.05);
    }

    &.active {
        background: #3d3d3d;
        color: #ffffff;

        img {
            filter: brightness(0) invert(1);
        }
    }
}

/* 金币容器基础样式 */
.coin-box {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.coin-area {
    user-select: none;
}

/* VIP信息区域基础样式 */
.vip-info-area {
    position: relative;

    /* 只显示上边框，避免和外层边框重叠 */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        pointer-events: none;
    }
}

/* 无会员样式 */
.coin-box-free {
    border: 1px solid #324a2d;

    .vip-info-area {
        background: linear-gradient(90deg,
                #1f321b 0%,
                #1b2320 50%,
                #171f1a 100%);

        .vip-text {
            background: linear-gradient(90deg, #feffb5 0%, #99f768 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
}

/* 入门会员样式 (PLAN_ENTRY) */
.coin-box-entry {
    border: 1px solid #2d454a;

    .vip-info-area {
        background: linear-gradient(90deg,
                #20383a 0%,
                #1b2123 50%,
                #171c1f 100%);

        .vip-text {
            background: linear-gradient(90deg, #b5ffe6 0%, #68d1f7 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
}

/* Basic会员样式 (PLAN_BASIC) */
.coin-box-basic {
    border: 1px solid #4a432d;

    .vip-info-area {
        background: linear-gradient(90deg,
                #393a20 0%,
                #23201b 50%,
                #1f1c17 100%);

        .vip-text {
            background: linear-gradient(90deg, #fdffb5 0%, #f7cc68 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
}

/* Pro会员样式 (PLAN_PRO) */
.coin-box-pro {
    border: 1px solid #4a432d;

    .vip-info-area {
        background: linear-gradient(90deg,
                #3a2020 0%,
                #231b1f 50%,
                #1f171d 100%);

        .vip-text {
            background: linear-gradient(90deg, #ffc0b5 0%, #f76868 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
}

/* 用户信息区域 */
.user-section {
    padding-top: 4;
}
</style>

<style>
.i-home-icon {
    mask: url('~/assets/images/menu/home.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/home.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-ai-video-icon {
    mask: url('~/assets/images/menu/video.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/video.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-ai-image-icon {
    mask: url('~/assets/images/menu/image.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/image.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-ai-tool-icon {
    mask: url('~/assets/images/menu/ai-tools.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/ai-tools.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-my-creations-icon {
    mask: url('~/assets/images/menu/my-creations.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/my-creations.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-used-his-icon {
    mask: url('~/assets/images/menu/usedHis.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/usedHis.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-pricing-icon {
    mask: url('~/assets/images/common/coin.webp') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/coin.webp') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-text-to-image-icon {
    mask: url('~/assets/images/menu/text-to-image.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/text-to-image.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-image-to-image-icon {
    mask: url('~/assets/images/menu/img-to-img.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/img-to-img.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-text-to-video-icon {
    mask: url('../assets/images/menu/text-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('../assets/images/menu/text-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-img-to-video-icon {
    mask: url('~/assets/images/menu/img-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/img-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-video-to-video-icon {
    mask: url('~/assets/images/menu/video-to-video.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/video-to-video.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-down-icon {
    mask: url('~/assets/images/common/down.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/down.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-video-effects-icon {
    mask: url('~/assets/images/menu/video-effects.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/video-effects.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-delete-icon {
    mask: url('~/assets/images/common/delete.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/delete.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-characters-icon {
    mask: url('~/assets/images/menu/characters.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/characters.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-ai-music-icon {
    mask: url('~/assets/images/menu/music.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/music.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-photo-effects-icon {
    mask: url('~/assets/images/menu/photo-effects.png') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/menu/photo-effects.png') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-share-link-icon {
    mask: url('~/assets/images/common/share_link.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/share_link.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-pen-icon {
    mask: url('~/assets/images/common/pen.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/pen.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.i-edit-pic-icon {
    mask: url('~/assets/images/common/edit_pic.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask: url('~/assets/images/common/edit_pic.svg') no-repeat center;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
}

.nav-links {
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.nav-links a,
.nav-links button {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #777779;
    transition: color 0.2s ease;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    appearance: none;
}

.nav-links .navIcon {
    width: 20px;
    height: 20px;
    display: inline-block;
    -webkit-mask-size: contain;
    background-image: none;
    background-color: currentColor;
    mask-size: contain;
}

.nav-links a:hover,
.nav-links button:hover {
    color: #99f768;
}

.i-nav-twitter-icon {
    mask: url('~/assets/images/icons/twitter.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/twitter.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
}

.i-nav-discord-icon {
    mask: url('~/assets/images/icons/discord.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/discord.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
}

.i-nav-instagram-icon {
    mask: url('~/assets/images/icons/instagram.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/instagram.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
}

.i-nav-tiktok-icon {
    mask: url('~/assets/images/icons/tiktok.svg') no-repeat center;
    -webkit-mask: url('~/assets/images/icons/tiktok.svg') no-repeat center;
    mask-size: contain;
    -webkit-mask-size: contain;
}
</style>
